import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-authaftergoogle',
	templateUrl: './authaftergoogle.component.html',
	styleUrls: ['./authaftergoogle.component.css'],
	standalone: true
})
export class AuthAfterGoogle implements OnInit {
	constructor(private router: Router) {}

	ngOnInit(): void {
		this.router.navigate(['home']);
	}
}
